import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import Button from '../../../../Common/DesignSystem/Button';
import { InlineInput } from '../../../../Common/DesignSystem/InlineInput';
import { DropdownItem } from '../../../../Common/DesignSystem/Input';
import { DivisionIcon, VCIcon } from '../../../../Common/Buttons/TypeIcons';

import { Heading6, P3Bold } from '../../../../Common/DesignSystem/Text';
import colours from '../../../../Common/DesignSystem/Colours';

const statusActions = [
  {
    iconName: "Order",
    label: "Order",
    color: colours.primary.grey01
  },
  {
    iconName: "Vehicle",
    label: "Inventory",
    color: colours.primary.blue
  },
  {
    iconName: "Clock",
    label: "To Be Retired",
    color: colours.accent.caution_yellow
  },
  {
    iconName: "RetireDate",
    label: "retired",
    color: colours.accent.error_red,
  },
]

// export const VehicleStatusCard = ({ vehicle = {}, editVehicle, setTab, latestReport, vehicle_usage_types, rr_vehicle, legacyApiVehicleData, match, history, closeModal }) => {
export const VehicleStatusCard = ({ vehicleForm, updateSelect, formDetails, setStarValue, isConvertingToVehicle }) => {
  const [selectedAction, setSelectedAction] = useState(0);
  const activeColor = statusActions[selectedAction].color;

  useEffect(() => {
    if (isConvertingToVehicle) {
      setSelectedAction(1);
    }
  }, [isConvertingToVehicle]);

  // useEffect(() => {
  //   const index = statusActions.findIndex((ac) => ac.label === vehicle.status)
  //   setSelectedAction(index)
  // }, [vehicle])

  // const retireVehicle = (vehicleId) => {
  //   history.push(`${match.url}/retire/${vehicleId}`);
  // }

  // const handleSelectAction = (actionIndex) => {
  //   const isRetireAction = statusActions[actionIndex].label === 'retired';
  //   if (isRetireAction) {
  //     retireVehicle(vehicle.V_ID);
  //   }

  //   // setSelectedAction(actionIndex);
  // }

  return (
    <div className="vehicle-status-card" style={{ borderColor: activeColor }}>
      <div className="vehicle-status-card__header" style={{ backgroundColor: activeColor }}>
        <Heading6
          style={{
            color: activeColor === colours.accent.caution_yellow ? colours.primary.grey01 : colours.primary.white
          }}
        >
          Status
        </Heading6>

        <div className="flex vehicle-status-card__action">
          {statusActions.map(({ label, iconName }, actionIndex) => {
            const isSelected = selectedAction === actionIndex
            const textColor = activeColor === colours.accent.caution_yellow ? colours.primary.grey01 : isSelected ? colours.primary.white : colours.primary.grey02;
            return (
              <>
                <button
                  key={actionIndex}
                  className="vehicle-status-card__action-button"
                  style={{
                    color: textColor,
                    borderColor: activeColor,
                    backgroundColor: isSelected ? activeColor : undefined
                  }}
                >
                  <Icon name={iconName} width="22px" height="22px" style={{ color: isSelected ? '#FFFFFF' : colours.primary.grey02 }} />
                  {isSelected && <P3Bold style={{ color: '#FFFFFF', marginRight: '2px' }}>{label}</P3Bold>}
                </button>
                {
                  actionIndex !== statusActions.length - 1 && <Icon class="type-icon" name="ChevronRight" height={20} size={16} style={{ color: colours.primary.grey01 }} />
                }
              </>
            )
          })}
        </div>
      </div>

      <div className="vehicle-status-card__content">
        <InlineInput label="Damage" value="No Damage" isInputOpen={false} />
        <InlineInput label="Reminders" value="No Reminders" isInputOpen={false} />
        <InlineInput label="Utilization" value={<><Icon name="Mileage" size={16} style={{ color: colours.primary.grey02 }} /> N/A</>} isInputOpen={false} />

        {formDetails?.oem_id === -9 && (
          <InlineInput required={isConvertingToVehicle} label="OEM" simple_dropdown name="oem_id" value={vehicleForm.oem_id} options={[{ value: -1, option: '' }, ...formDetails?.oems]} onChange={(e) => { updateSelect({ name: 'oem_id', value: e.target.value }) }} />
        )}

        {vehicleForm.oem_id && vehicleForm.oem_id !== -9 ? (
          <InlineInput
            label="Pool"
            dropdown
            name="sh_id"
            // readOnly={!isCreatingVehicle}
            required={isConvertingToVehicle}
            value={vehicleForm.sh_id}
            onChange={(e) => updateSelect({ name: 'sh_id', value: e.currentTarget.dataset.id })}
            renderDropdownLabel={
              <>
                {formDetails?.divisions?.find(obj => obj.value == vehicleForm.sh_id) ? (
                  <div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {DivisionIcon(formDetails?.divisions?.find(obj => obj.value == vehicleForm.sh_id), 16, null, null, true)}
                    {formDetails?.divisions?.find(obj => obj.value == vehicleForm.sh_id)?.option}
                  </div>
                ) : vehicleForm.stakeholder ? (
                  <div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {DivisionIcon(vehicleForm.stakeholder, 16, null, null, true)}
                    {vehicleForm.stakeholder.Company + " - " + vehicleForm.stakeholder.Division}
                  </div>
                ) : null}
              </>
            }
          >
            {formDetails?.divisions?.length && formDetails.divisions.map((pool) =>
              <DropdownItem key={pool.option} label={pool.option} value={pool.value} render_leading_ic={DivisionIcon(pool, 16, null, null, true)}/>
            )}
          </InlineInput>
        ) : (
          <InlineInput required={isConvertingToVehicle} label="Pool" placeholder="Please select the OEM" disabled />
        )}

        {vehicleForm.sh_id && vehicleForm.oem_id !== -9 ? (
          <InlineInput
            label="Facility"
            dropdown
            name="vmh_id"
            // readOnly={(!(isCreatingVehicle))}
            required={isConvertingToVehicle}
            value={vehicleForm.vmh_id}
            onChange={(e) => updateSelect({ name: 'vmh_id', value: e.currentTarget.dataset.id })}
            renderDropdownLabel={
              <>
                {formDetails?.vmhs?.find(obj => obj.value == vehicleForm.vmh_id) ?(
                  <div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {VCIcon(formDetails?.vmhs?.find(obj => obj.value == vehicleForm.vmh_id), 16, null, null, true)}
                    {formDetails?.vmhs?.find(obj => obj.value == vehicleForm.vmh_id)?.option}
                  </div>
                ) : vehicleForm.vmh ? (
                  <div className="ds-input-dropdown-label" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {VCIcon(vehicleForm.vmh, 16, null, null, true)}
                    {vehicleForm.vmh.Display_Name + " - " + vehicleForm.vmh.Display_City}
                  </div>
                ) : null}
              </>
            }
          >
            {formDetails?.vmhs?.length && formDetails.vmhs.map((vmh) =>
              <DropdownItem label={vmh.option} value={vmh.value} render_leading_ic={VCIcon(vmh, 16, null, null, true)}/>
            )}
          </InlineInput>
        ) : (
          <InlineInput required={isConvertingToVehicle} label="Facility" placeholder="Please select the Pool" disabled />
        )}

        <InlineInput label="Tier" value={vehicleForm.star} onChange={setStarValue} selectStars mutable type="Vehicle" />
      </div>
    </div>
  )
};
